import React from "react";
import { useNavigate } from "react-router-dom";
import Body from "src/components/common/Body";
import List from "src/components/common/List";
import Button from "src/components/common/Button";
import styled from "styled-components";
import AlarmSettingItem from "src/components/alarm/AlarmSettingItem";
import EtcAlarmSettingItem from "src/components/alarm/EtcAlarmSettingItem";

const alarmSetting = () => {
  const navigate = useNavigate();

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
            알림설정
          </Button>
        </div>
      </header>

      <Body>
        <TitleSet>A/S 접수</TitleSet>
        <List bg="#f4f4f4" pd="15px" itemPd="18px 0" lastBd={false}>
          <AlarmSettingItem />
        </List>

        <TitleSet>기타</TitleSet>
        <List bg="#f4f4f4" pd="15px" itemPd="18px 0" lastBd={false}>
          <EtcAlarmSettingItem />
        </List>
      </Body>
    </>
  );
};

const TitleSet = styled.h3`
  padding: 40px 15px 20px;
  font-size: 16px;
  font-weight: 700;
`;

export default alarmSetting;
